

import { Injectable } from '@angular/core';
import { Validation, Style } from '../models/base.interface';
import { PageConfig } from '../models/page.interface';
import { SectionConfig } from '../models/section.interface';
import { FieldConfig } from '../models/field.interface';
import * as _ from 'lodash';

@Injectable()
export class ParserService {

    constructor() { }

    parseForm(form);
    parseForm(form, data);
    parseForm(form, data, inputData);
    parseForm(form, data, inputData, customData);

    parseForm(form, data?, inputData?, customData?) {

        const schema = form.schema;
        const validations = form.validation;
        const styles = form.styles;
        const layout = form.layout;
        const behaviour = form.behaviour;

        var pageConfigs: PageConfig[] = [];

        _.forIn(schema, (pages, formKey) => {

            _.forEach(pages, (page) => {
                const pageTitle = page.meta ? page.meta.title : '';

                var pageConfig: PageConfig = {};
                pageConfig.name = pageTitle;
                pageConfig.sections = [];
                pageConfig.type = 'page';
                pageConfig.validation = this.parseValidation(pageConfig, validations);
                pageConfig.style = this.parseStyle(pageConfig, styles);
                pageConfig.customData = customData;

                _.forIn(page, (sections, pageKey) => {
                    if (pageKey !== 'meta') {
                        pageConfig.id = pageKey;
                        _.forEach(sections, (section) => {

                            const sectionTitle = section.meta ? section.meta.title : '';

                            var sectionConfig: SectionConfig = {};
                            sectionConfig.name = sectionTitle;
                            sectionConfig.type = 'section';
                            sectionConfig.fields = [];
                            sectionConfig.page = pageConfig;
                            sectionConfig.validation = this.parseValidation(sectionConfig, validations);
                            sectionConfig.style = this.parseStyle(sectionConfig, styles);
                            sectionConfig.json = section;

                            _.forIn(section, (fields, sectionKey) => {
                                if (sectionKey !== 'meta') {
                                    sectionConfig.id = sectionKey;
                                    _.forEach(fields, (field) => {

                                        var fieldConfig = this.parseField(field, data, inputData);
                                        fieldConfig.validation = this.parseValidation(fieldConfig, validations);
                                        fieldConfig.style = this.parseStyle(fieldConfig, styles);
                                        fieldConfig.behaviour = this.parseBehaviour(fieldConfig, behaviour);
                                        fieldConfig.section = sectionConfig;
                                        sectionConfig.fields.push(fieldConfig);
                                    });

                                    sectionConfig.dynamic = (section['meta'].dynamic && section['meta'].dynamic === "true") ? true : false;
                                    //To stop recursive dynamic section
                                    if (sectionConfig.dynamic === true) {
                                        sectionConfig.value = data['data'][sectionKey];
                                        sectionConfig.json['meta']['dynamic'] = false;
                                        sectionConfig.formValidationJson = validations;
                                        sectionConfig.formValidationJson[sectionConfig.id + '_title'] = { "required": "true" }
                                    }
                                }
                            });

                            pageConfig.sections.push(sectionConfig);
                        });
                    }
                });

                pageConfigs.push(pageConfig);
            });
        });

        return pageConfigs;
    }

    parseField(field, data, inputData) {

        var fieldConfig: FieldConfig = {};
        _.forIn(field, (fieldProps, fieldKey) => {

            fieldConfig.name = fieldProps.title;
            fieldConfig.id = fieldKey;
            fieldConfig.type = fieldProps.type;
            fieldConfig.dynamic = (fieldProps.dynamic && (fieldProps.dynamic === "true" || fieldProps.dynamic === true)) ? true : false;
            fieldConfig.additionalInfo = (fieldProps.addInfo && (fieldProps.addInfo === "true" || fieldProps.addInfo === true)) ? true : false;
            fieldConfig.showHeader = (fieldProps.showHeader && (fieldProps.showHeader === "true" || fieldProps.showHeader === true)) ? true : false;
            fieldConfig.data = fieldProps.data ? fieldProps.data : undefined;
            fieldConfig.default = fieldProps.default;

            if (data && data.data && data.data[fieldKey]) {
                fieldConfig.value = data.data[fieldKey];
            }

            if (data && data.errors && data.errors[fieldKey]) {
                fieldConfig.errorMessage = data.errors[fieldKey];
            }

            //Assigning prefill input data to field
            if (inputData && inputData[fieldKey]) {
                if (fieldConfig.type === 'label') {
                    fieldConfig.name += "\n -" + inputData[fieldKey];
                } else {
                    fieldConfig.data = inputData[fieldKey];
                }
            }

            if (fieldProps.refImage) {
                fieldConfig.refImage = fieldProps.refImage;
            }
        });

        return fieldConfig;
    }

    parseValidation(field, validations) {

        const fieldKey = field.id;
        var validation: Validation = { isRequired: false };
        if (validations[fieldKey]) {

            validation.isRequired = (validations[fieldKey]['required'] && validations[fieldKey]['required'] === "true") ? true : false;
            validation.onChange = validations[fieldKey]['on_change'] ? validations[fieldKey]['on_change'] : undefined;
        }

        return validation;
    }

    parseStyle(field, styles) {

        const fieldKey = field.id;
        var style: Style = { visibility: true, editability: true, background_color: '(255,255,255)', border_color: '(196, 197, 199)', border_thickness: 1, corner_radius: 3 };
        if (styles[fieldKey]) {

            style.visibility = (styles[fieldKey]['visibility'] && styles[fieldKey]['visibility'] === "false") ? false : true;
            style.editability = (styles[fieldKey]['editability'] && styles[fieldKey]['editability'] === "false") ? false : true;
            style.border_color = (styles[fieldKey]['background_color'] && styles[fieldKey]['background_color']) ? styles[fieldKey]['background_color'] : undefined;
            style.border_color = (styles[fieldKey]['border_color'] && styles[fieldKey]['border_color']) ? styles[fieldKey]['border_color'] : undefined;
            style.border_thickness = (styles[fieldKey]['border_thickness'] && styles[fieldKey]['border_thickness']) ? styles[fieldKey]['border_thickness'] : undefined;
            style.corner_radius = (styles[fieldKey]['corner_radius'] && styles[fieldKey]['corner_radius']) ? styles[fieldKey]['corner_radius'] : undefined;
        }

        return style;
    }

    parseBehaviour(field, behaviourObj) {

        const fieldKey = field.id;
        if (behaviourObj && behaviourObj[fieldKey]) {
            return behaviourObj[fieldKey];
        }

        return undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/rFF/services/parser.service.ts